<script setup>
import {defineProps, ref, onMounted} from 'vue'
import slugify from 'slugify'

const props = defineProps({
  title: String,
  deprecated: {
    type: Boolean,
    default: false
  }
});

</script>


<template>
<div :id="slugify(props.title)">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h2 class="mb-3 jura">
          {{ props.title }}
          <span v-if="props.deprecated" class="badge-deprecated ms-2">DEPRECATED</span>
        </h2>
      </div>
      <div class="col-md-6 left-side">
        <slot name="left"></slot>
      </div>
      <div class="col-md-6">
        <div style="position: sticky; top: 1rem;">
          <slot name="right"></slot>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<style scoped>
.badge-deprecated {
  background-color: #dc3545;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 600;
  vertical-align: middle;
}
</style>
